import React from "react";

const Multibrand = () => {
  return <div></div>;
};

export default Multibrand;
